import axios from "axios";

// Safe base URL
const BASE = (
  process.env.REACT_APP_DEV_BACKURL || window.location.origin
).replace(/\/+$/, "");

const api = axios.create({
  baseURL: BASE,
});

// ✅ Request Interceptor — universal for all /api/* routes
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("sa_jwt"); // same key used by both SA and VA
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    /* no-op */
  }
  return config;
});

// Optional: global 401 handling
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      console.warn("Unauthorized — clearing token");
      localStorage.removeItem("sa_jwt");
      localStorage.removeItem("va_ctx");
      // optionally redirect to login
      // window.location.href = "/super-admin/login";
    }
    return Promise.reject(err);
  }
);

export default api;
